import { CircleAlertIcon, PauseIcon } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "../../ui/alert";
import { Spinner } from "../../ui/spinner";
import { inspectionActive, type InspectionRun } from "./inspectorView";
import { inspectionOutcome } from "./runPresentation";

/** Stays above both tabs, including when a run fails before its first note. */
export function InspectionRunAlert({ run }: { readonly run: InspectionRun }) {
  if (run.status === "completed") return null;
  const failed = run.status === "failed";
  const outcome = inspectionOutcome(run);
  return (
    <Alert
      variant={failed ? "error" : run.status === "interrupted" ? "warning" : "info"}
      role={failed ? "alert" : "status"}
      controlAlignment="first-line"
    >
      {inspectionActive(run) ? (
        <Spinner className="size-4" />
      ) : failed ? (
        <CircleAlertIcon aria-hidden className="size-4" />
      ) : (
        <PauseIcon aria-hidden className="size-4" />
      )}
      <AlertTitle>{outcome.title}</AlertTitle>
      <AlertDescription className="break-words">{outcome.detail}</AlertDescription>
    </Alert>
  );
}
